import { usePage } from "@inertiajs/vue3";

export function useLog() {
    const page = usePage();
    const env = page.props.app.environment;
    const user = page.props.user;

    let show = false;

    if (env === "local" || user?.id === 1) {
        show = true;
    }

    const debug = (...args: any[]) => {
        if (show) {
            console.debug("[DOKKAN.FYI debug]", ...args);
        }
    };

    const info = (...args: any[]) => {
        if (show) {
            console.info("[DOKKAN.FYI info]", ...args);
        }
    };

    const warn = (...args: any[]) => {
        if (show) {
            console.warn("[DOKKAN.FYI warn]", ...args);
        }
    };

    const error = (...args: any[]) => {
        if (show) {
            console.error("[DOKKAN.FYI error]", ...args);
        }
    };

    return {
        debug,
        info,
        warn,
        error,
    };
}
